<template>
    <USelectMenu
        v-model="selectedDepartment"
        :items="departmentOptions"
        :ui="ui ?? defaultUi"
        :size="size"
        label-key="name"
        placeholder="Avdeling"
        create-item
        :default-open="defaultOpen"
        @create="addDepartment"
    >
        <template v-if="selectedDepartment" #trailing>
            <UButton
                color="neutral"
                variant="ghost"
                size="sm"
                icon="i-ph-x"
                title="Fjern avdeling"
                @click.stop="clearDepartment"
            />
        </template>
    </USelectMenu>
</template>

<script setup lang="ts">
import {createDimension, Department, useDimensions} from '@/dimensions/dimensions.service'
import {computed} from 'vue'
import {SelectMenuItem} from '@nuxt/ui'

const {departments, newDepartment} = useDimensions()
const selectedDepartmentName = defineModel<string>({required: false})


const props = defineProps({
    defaultOpen: {type: Boolean, default: false},
    theme: {type: String, default: ''}, //TODO: Type to available theme classes?
    size: {type: String, default: 'sm'},
    ui: {type: Object, default: undefined}
})

const defaultUi = {
    content: 'z-1 min-w-fit' + props.theme,
    trailing: 'absolute right-0 pr-1'
}

type DepartmentOption = Department & SelectMenuItem

const departmentOptions = computed<DepartmentOption[]>(() => {
    return departments.value.map(department => department as DepartmentOption)
})

const selectedDepartment = computed<DepartmentOption>({
    get: () => {
        return departments.value.find(department => department.name === selectedDepartmentName.value) as DepartmentOption
    },
    set: (value: Department) => {
        selectedDepartmentName.value = value.name
    }
})

const addDepartment = (newTagName: string) => {
    const department = newDepartment(newTagName)
    createDimension(department)
        .then(() => {
            selectedDepartment.value = department as DepartmentOption
        })
}

const clearDepartment = () => {
    selectedDepartmentName.value = ''
}
</script>

<style>
</style>